'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildMessage = undefined;

var _pipe = require('transmute/pipe');

var _pipe2 = _interopRequireDefault(_pipe);

var _PubNubMessageRecord = require('../../pubnub-message/records/PubNubMessageRecord');

var _PubNubMessageRecord2 = _interopRequireDefault(_PubNubMessageRecord);

var _propertyValues = require('../../lib/propertyValues');

var _timestamps = require('../../lib/timestamps');

var _buildMetadataRecord = require('./buildMetadataRecord');

var _buildMetadataRecord2 = _interopRequireDefault(_buildMetadataRecord);

var _buildMessageDescriptorRecord = require('./buildMessageDescriptorRecord');

var _buildMessageDescriptorRecord2 = _interopRequireDefault(_buildMessageDescriptorRecord);

var _generateUuid = require('../../common-message-format/generateUuid');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var buildMessage = exports.buildMessage = function buildMessage() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return (0, _pipe2.default)((0, _propertyValues.setDefaultValues)({
    id: (0, _generateUuid.generateUuid)(),
    clientTs: (0, _timestamps.generateUniqueClientTimestamp)('PubNubMessageFactory-clientTs'),
    timestamp: (0, _timestamps.generateUniqueClientTimestamp)('PubNubMessageFactory-timestamp')
  }), (0, _propertyValues.enforceValues)({
    metadata: (0, _buildMetadataRecord2.default)(props),
    descriptor: (0, _buildMessageDescriptorRecord2.default)(props)
  }), _PubNubMessageRecord2.default)(props);
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/factories/PubNubMessageFactory/buildMessage.js
// module id = 706
// module chunks = 2 3